export const INGREDIENTS_AND_NUTRIENTS_HOST = 'https://fdc-api.winglegroup.com';

export const INGREDIENTS_AND_NUTRIENTS = {
  foodByGTIN: `${INGREDIENTS_AND_NUTRIENTS_HOST}/fdc/food`,
  dsldFood: `${INGREDIENTS_AND_NUTRIENTS_HOST}/dsld/food`,
};
